export default class Menu {
  id;
  categories;

  constructor(id, categories) {
    this.id = id;
    this.categories = categories;
  }

  removeRestrictedItemsFromSelf() {
    if (this.categories && Array.isArray(this.categories)) {
      this.categories = this.categories.map(category => {
        if (category.items && Array.isArray(category.items)) {
          category.items = category.items.filter(item => {
            return !item.restricted;
          });
        }
        return category;
      });
    }
  }

  static firebaseConverter = {
    fromFirestore(snapshot, options) {
      let id = snapshot.id;
      const data = { id, ...snapshot.data(options) };

      return new Menu(data.id, data.categories);
    },

    toFirestore(menu) {
      let { id, categories } = menu;
      return {
        id,
        categories
      };
    }
  };
}
